// src/api/axiosInstance.ts
import axios, { AxiosInstance } from 'axios';
import { ENV } from '../config/envConfig';
import {
  getAccessToken,
  // getRefreshToken,
  // setTokens,
  // clearTokens,
} from './tokenUtils';

// Instance cache to avoid creating duplicate instances for same base URL
const instanceCache = new Map<string, AxiosInstance>();

// Simple refresh token logic
// let isRefreshing = false;
// let failedQueue: Array<{
//   resolve: (value?: any) => void;
//   reject: (reason?: any) => void;
// }> = [];

// const processQueue = (error: any, token: string | null = null) => {
//   failedQueue.forEach(({ resolve, reject }) => {
//     if (error) {
//       reject(error);
//     } else {
//       resolve(token);
//     }
//   });

//   failedQueue = [];
// };

// Clean interceptor setup
const setupInterceptors = (
  instance: AxiosInstance,
  requiresAuth: boolean = false
) => {
  // Add token to requests if auth required
  instance.interceptors.request.use(config => {
    if (requiresAuth) {
      const token = getAccessToken();
      if (token) {
        config.headers.Authorization = `Bearer ${token}`;
      }
    }
    return config;
  });

  // Handle 401 errors with token refresh
  instance.interceptors.response.use(
    response => response,
    async error => {
      // const originalRequest = error.config;

      // // Check if 401 error and we have refresh token
      // if (error.response?.status === 401 && getRefreshToken() && !originalRequest._retry) {

      //   // If already refreshing, queue this request
      //   if (isRefreshing) {
      //     return new Promise((resolve, reject) => {
      //       failedQueue.push({ resolve, reject });
      //     }).then((token) => {
      //       originalRequest.headers.Authorization = `Bearer ${token}`;
      //       return instance(originalRequest);
      //     });
      //   }

      //   originalRequest._retry = true;
      //   isRefreshing = true;

      //   try {
      //     // Refresh the token
      //     const response = await axios.post(ENV.REFRESH_URL, {
      //       refreshToken: getRefreshToken()
      //     }, {
      //       baseURL: ENV.API_BASE_URL,
      //       timeout: ENV.REFRESH_TIMEOUT
      //     });

      //     const { accessToken, refreshToken } = response.data;

      //     // Update tokens
      //     setTokens(accessToken, refreshToken);

      //     // Process queued requests
      //     processQueue(null, accessToken);

      //     // Retry original request
      //     originalRequest.headers.Authorization = `Bearer ${accessToken}`;
      //     return instance(originalRequest);

      //   } catch (refreshError) {
      //     // Refresh failed - clear tokens and reject all queued requests
      //     processQueue(refreshError, null);
      //     clearTokens();
      //     return Promise.reject(refreshError);
      //   } finally {
      //     isRefreshing = false;
      //   }
      // }

      return Promise.reject(error);
    }
  );
};

// Default axios instance
const axiosInstance = axios.create({
  baseURL: ENV.API_BASE_URL,
  timeout: ENV.API_TIMEOUT,
  headers: {
    'Content-Type': 'application/json',
  },
});

setupInterceptors(axiosInstance, false);

// Function to create custom axios instance with caching by base URL
export const createAxiosInstance = (
  baseURL?: string,
  requiresAuth: boolean = false,
  timeout?: number
): AxiosInstance => {
  // Use base URL as cache key
  const base = baseURL || ENV.API_BASE_URL;

  // Return cached instance if it exists for same base URL
  if (instanceCache.has(base)) {
    return instanceCache.get(base)!;
  }

  // Create new instance
  const customInstance = axios.create({
    baseURL: base,
    timeout: timeout || ENV.API_TIMEOUT,
    headers: {
      'Content-Type': 'application/json',
    },
  });

  // Setup interceptors
  setupInterceptors(customInstance, requiresAuth);

  // Cache the instance by base URL
  instanceCache.set(base, customInstance);

  return customInstance;
};

export default axiosInstance;
